// Round the number to a specified number of decimal places.
export function roundNumber(num, decimals = 2) {
  if (typeof num !== 'number') {
    return num
  }
  const factor = Math.pow(10, decimals)
  return Math.round(num * factor) / factor
}
